export default ({ color, fontSize, typography }) => ({
  filterByValueContainer: {
    height: '86%',
    overflowY: 'auto',
  },
  containerSpacing: {
    padding: 20,
  },
  valueContainer: {
    marginBottom: 12,
  },
  textInput: {
    marginRight: 20,
    width: 176,
    display: 'inline-block',
    '& input': {
      height: 36,
      width: '100%',
      marginBottom: 0,
      color: color.bodyText,
      fontFamily: typography.bodyText,
      fontSize: fontSize.small,
      padding: '9px 8px 7px 8px',
      borderColor: color.borderColor,
    },
    '& div': {
      height: 36,
      borderColor: color.borderColor,
    },
    '&:hover div': {
      borderColor: color.borderColor,
    },
    '& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
    },
  },
  valueField: {
    marginBottom: '0px !important',
    marginTop: '0px !important',
  },
  textBox: {
    alignItems: 'end',
    display: 'flex',
  },
  textFieldLabel: {
    display: 'none',
  },
  textAndError: {
    '& input': {
      borderColor: color.borderColorError,
    },
    '&:focus div': {
      boxShadow: `0 0 0 1px #ffffff, 0 0 0 2px ${color.borderColorError}`,
    },
    '& input:focus + div': {
      boxShadow: '0 0 0 1px #ffffff, 0 0 0 2px transparent',
      borderColor: color.borderColorError,
    },
    '& div': {
      borderColor: color.borderColorError,
    },
  },
  button: {
    margin: '10px 10px',
  },
  filterLabel: {
    fontSize: fontSize.small,
  },
  label: {
    marginBottom: 5,
    color: color.smallText,
    fontFamily: typography.smallText,
    fontSize: fontSize.smallText,
  },
  errorMessage: {
    marginTop: 2,
    marginBottom: 0,
    color: color.red,
    fontSize: fontSize.smallText,
  },
  removeValueButton: {
    color: color.primaryButtonBackground,
    background: color.primaryButtonText,
    borderRadius: 3,
    fontFamily: typography.buttonText,
    fontSize: fontSize.buttonText,
    border: '1px solid',
    borderColor: color.primaryButtonBackground,
    height: 40,
    fontWeight: 'normal!important',
    marginLeft: 20,
    marginBottom: 10,
  },
});